<template>
    <div>
        <div v-for="(popup, index) in items" v-bind:key="'popup-' + index" class="product-card card br p-t-3 p-b-3 m-b-4">
            <div class="card-content row row-middle row-compress">
                <div class="slat-content column">
                    <h4 class="card-title c-primary f-s-4 m-b-0">
                        <a class="c-primary" href="#edit-popup" v-on:click="editPopup(index)">
                            {{ popup.name }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="injected-svg icon m-b-1 m-l-2 inject-svg i-size-small">
                                <path d="M15.7 4.3c-.4-.4-1-.4-1.4 0l-10 10c-.2.2-.3.4-.3.7v4c0 .6.4 1 1 1h4c.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4l-4-4zM8.6 18H6v-2.6l6-6 2.6 2.6-6 6zm7.4-7.4L13.4 8 15 6.4 17.6 9 16 10.6z" class="icon"></path>
                            </svg>
                        </a>
                    </h4>
                    <p v-if="priceLine(popup)" class="c-medium-tint f-s-3">{{ priceLine(popup) }}</p>
                </div>
                <div class="slat-aside text-right m-r-4">
                    <sales-popup-dropdown-menu
                        v-bind:index="index"
                        v-bind:preview-link="popup.preview_url"
                        v-on:trigger="handleDropdownAction"
                    ></sales-popup-dropdown-menu>
                </div>
            </div>

            <input type="hidden" v-bind:name="'sales_popups[' + index + '][encoded_id]'" v-bind:value="popup.encoded_id" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][name]'" v-bind:value="popup.name" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][image]'" v-bind:value="popup.image" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][video]'" v-bind:value="popup.video_url" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][video_type]'" v-bind:value="popup.video_type" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][video_image]'" v-bind:value="popup.video_image" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][content][headline]'" v-bind:value="popup.content.headline" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][content][body]'" v-bind:value="popup.content.body" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][content][price]'" v-bind:value="popup.content.price" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][content][button_label]'" v-bind:value="popup.content.buttonLabel" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][content][button_color]'" v-bind:value="popup.content.buttonColor" />
            <input type="hidden" v-bind:name="'sales_popups[' + index + '][content][button_url]'" v-bind:value="popup.content.buttonUrl" />
        </div>

        <div class="text-center p-t-3">
            <button v-on:click="newPopup" type="button" class="btn btn-text btn-text--accent btn-icon m-b-4">
                <span class="icon i-container i-filled-accent">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon i-size-small inline"><g class="icon"><path d="M11 5v14h2V5z"></path><path d="M19 11H5v2h14z"></path></g></svg>
                </span>
                {{ trans('Add Sales Popup') }}
            </button>
        </div>

        <sales-popup-modal
            v-if="modalShow"
            ref="modal-popup"
            v-bind:key="modalKey"
            v-bind:membership="membership"
            v-bind:pricing-plans="pricingPlans"
            v-bind:default-button-color="defaultButtonColor"
            v-on:save="savePopup"
            v-on:delete="deletePopup"
        ></sales-popup-modal>

        <input type="hidden" v-bind:name="'for_removal[' + index + ']'" v-for="(id, index) in forRemoval" v-bind:value="id" v-bind:key="'remove-' + id" />
    </div>
</template>
<script>
import { EventBus } from '../../event-bus.js';
import SalesPopupModal from './SalesPopupModal.vue';
import SalesPopupDropdownMenu from './SalesPopupDropdownMenu.vue';

export default {
    components: {
        SalesPopupModal,
        SalesPopupDropdownMenu,
    },
    props: {
        salesPopups: {
            type: Array,
            required: true,
        },
        pricingPlans: {
            type: Array,
            required: true,
        },
        membership: {
            type: Object,
            required: true,
        },
        defaultButtonColor: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            items: this.salesPopups.map(popup => ({ ...popup })),
            modalShow: false,
            modalKey: 1,
            forRemoval: [],
        };
    },
    methods: {
        newPopup() {
            this.modalShow = true;

            this.$nextTick(() => {
                this.$refs['modal-popup'].show = true;
            });
        },
        editPopup(index) {
            this.modalShow = true;

            this.$nextTick(() => {
                this.$refs['modal-popup'].show = true;
                this.$refs['modal-popup'].index = index;
                this.$refs['modal-popup'].loadPopup(this.items[index]);
            });
        },
        savePopup(popup, index) {
            if (index !== null) {
                this.$set(this.items, index, popup);
            } else {
                this.items.push(popup);
            }

            this.closeModal();

            this.$nextTick(() => {
                EventBus.$emit('form:check');
            });
        },
        deletePopup(index) {
            if (this.items[index].encoded_id) {
                this.forRemoval.push(this.items[index].encoded_id);
            }

            this.items.splice(index, 1);
            this.closeModal();

            this.$nextTick(() => {
                EventBus.$emit('form:check');
            });
        },
        closeModal() {
            this.modalShow = false;
            this.modalKey++;
        },
        priceLine(popup) {
            if ( ! popup.content.price || popup.content.price === 'hide' || this.pricingPlans.length === 0) {
                return null;
            }

            if (popup.content.price === 'first') {
                return this.pricingPlans[0].name;
            }

            let pricingPlan = this.pricingPlans.find(plan => plan.encoded_id === popup.content.price);

            if ( ! pricingPlan) {
                return null;
            }

            return pricingPlan.name;
        },
        handleDropdownAction(action, index) {
            if (action === 'edit') {
                // Handle edit action
                this.editPopup(index);
            } else if (action === 'delete') {
                // Handle delete action
                this.deletePopup(index);
            }
        },
    },
    mounted() {
        if (window.location.hash === '#create-sales-popup') {
            this.newPopup();
        }

        if (window.location.hash.startsWith('#edit-sales-popup-')) {
            let encodedId = window.location.hash.replace('#edit-sales-popup-', '');
            let index = this.items.findIndex(popup => popup.encoded_id === encodedId);

            if (index !== -1) {
                this.editPopup(index);
            }
        }
    },
};
</script>
